<div [ngClass]="innerModal ? 'servc-modal inner-modal' : 'servc-modal'">
  <div [ngClass]="bigSize ? 'inner-container' : 'inner-container-small'" class="modal-box-shadow" #spinnerDiv>
    <div [ngClass]="bigSize ? 'space-between-flex-start' : titleDirection + '-row-container' " class="row-gap-0p5">
      <button *ngIf="buttons?.back" type="button" class="modal-button back-button-size"
        (click)="closeButtonClicked.emit()">
        <svg class="svg-arrow-back" width="24" height="24" viewBox="0 0 24 24" fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="M15.7071 5.29289C16.0976 5.68342 16.0976 6.31658 15.7071 6.70711L10.4142 12L15.7071 17.2929C16.0976 17.6834 16.0976 18.3166 15.7071 18.7071C15.3166 19.0976 14.6834 19.0976 14.2929 18.7071L8.29289 12.7071C7.90237 12.3166 7.90237 11.6834 8.29289 11.2929L14.2929 5.29289C14.6834 4.90237 15.3166 4.90237 15.7071 5.29289Z"
            fill="#00948e" />
        </svg>
        {{backString}}
      </button>
      <div
        *ngIf="title"
        data-qa="modal-container-title"
        [ngClass]="{'min-height-2p125' : buttons.upperRight1 || buttons.upperRight2}"
        class="{{bigSize ? 'title-2 bold700 max-width-26' : 'font-1 bold600'}} start-row-container {{titleStyles}}" [innerHTML]="title">
        <span *ngIf="greenTitle" data-qa="modal-container-green-title" class="main-8"> {{greenTitle}}</span>
      </div>

      <div *ngIf="buttons?.upperRight1 || buttons?.upperRight2" class="centered-row-container row-gap-0p5">
        <button *ngIf="buttons.upperRight1" type="button" class="modal-button button-size {{buttons.upperRight1Class}}"
          (click)="upperRight1ButtonClicked.emit()">
          {{buttons.upperRight1}}
        </button>

        <div *ngIf="buttons?.upperRight2" [ngClass]="{'cursor-not-allowed': !upperRight2Activated}">
          <button type="button" class="modal-button button-size {{buttons.upperRight2Class}}"
            (click)="upperRight2ButtonClicked.emit()" [disabled]="!upperRight2Activated">
            {{buttons.upperRight2}}
          </button>
        </div>
      </div>
    </div>
    <div *ngIf="bigSize && title" class="whitespace-1"></div>
    <div class="black-line for-padding-1p25" *ngIf="bigSize && title"></div>
    <div *ngIf="subtitle" class="whitespace-0p5"></div>
    <div *ngIf="subtitle" class="modal-subtitle">
      {{subtitle}}
    </div>

    <div *ngIf="title && showWhiteSpace" class="whitespace-1p25"></div>
    <!-- Your code is down here-->
    <ng-content></ng-content>
    <!-- Your code is  up  here-->
    <div *ngIf="buttons && (buttons.apply || buttons.dismiss || buttons.lowerLeft)" class="whitespace-1p25"></div>

    <div *ngIf="!buttons?.lowerLeft && !buttons?.dismissApplyAlignRight" class="centered-row-container row-gap-0p5" >
      <app-button *ngIf="buttons?.dismiss"
        data-qa="modal-container-dismiss-button"
        [size]="'modal-container-button'"
        [type]="'default'"
        [additionalClasses]="'width-6'"
        (buttonClick)="dismissButtonClicked.emit()">
        {{buttons.dismiss}}
     </app-button>
      <div [ngClass]="{'cursor-not-allowed': !applyActivated}" title="{{applyHint}}">
        <app-button *ngIf="buttons?.apply"
          data-qa="modal-container-apply-button"
          [size]="'modal-container-button'"
          [type]="'accent'"
          [additionalClasses]="buttons.applySize ?? 'width-6'"
          [disabled]="!applyActivated"
          (buttonClick)="applyButton()">
          {{buttons.apply}}
        </app-button>
      </div>
    </div>

    <div
      *ngIf="buttons && (buttons.lowerLeft || buttons.dismissApplyAlignRight)"
      [ngClass]="buttons.dismissApplyAlignRight ?'modal-align-right-row':'modal-spacebetween-row'">
      <div [ngClass]="{'cursor-not-allowed': !lowerLeftActivated}" title="{{lowerLeftHint}}">
        <app-button *ngIf="buttons.lowerLeft"
          data-qa="modal-container-lower-left-button"
          [size]="'modal-container-button'"
          [type]="buttons.lowerLeftClass ?? 'default'"
          [disabled]="!lowerLeftActivated"
          [showIcon]="buttons.lowerLeftIcon ? 'left' : null"
          [iconName]="buttons.lowerLeftIcon"
          (buttonClick)="lowerLeftButtonClicked.emit()">
          {{buttons.lowerLeft}}
        </app-button>
      </div>
      <div class="centered-row-container row-gap-0p5">
        <app-button *ngIf="buttons.dismiss"
          data-qa="modal-container-dismiss-button"
          [size]="'modal-container-button'"
          [type]="'default'"
          [additionalClasses]="'width-6'"
          (buttonClick)="dismissButtonClicked.emit()">
          {{buttons.dismiss}}
        </app-button>
        <div [ngClass]="{'cursor-not-allowed': !applyActivated}" title="{{applyHint}}">
          <app-button *ngIf="buttons.apply"
            data-qa="modal-container-apply-button"
            [size]="'modal-container-button'"
            [type]="'accent'"
            [disabled]="!applyActivated"
            [additionalClasses]="'width-6'"
            (buttonClick)="applyButton()">
            {{buttons.apply}}
          </app-button>
        </div>
      </div>
    </div>

    <div *ngIf="buttons?.close" class="close-modal" (click)="closeButtonClicked.emit()">
      <img src="../../../../../assets/svg/common/close.svg" alt="close">
    </div>
  </div>
</div>
